import React, { useEffect,useState } from "react";
import JdEventsPage from "../../JdEventsPage";

export default function NuJobsEvents(props) {
  return (
    <div className="nujobspostedjds-wrapper">
       <JdEventsPage product = {"nujobs"}/>
    </div>  
  );
}
